import { z } from 'zod'

export const getCityByLocationResponseSchema = z.object({
  /** 城市編號 */
  cityId: z.string()
})

export interface GetCityByLocationResponse extends z.infer<
  typeof getCityByLocationResponseSchema
> {}
